import { render, staticRenderFns } from "./app.vue?vue&type=template&id=f5c55388&scoped=true&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"
import style0 from "./app.vue?vue&type=style&index=0&id=f5c55388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c55388",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/baikaifa/Desktop/codes/baikaifa-overwrite-skeleton-webpack-plugin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5c55388')) {
      api.createRecord('f5c55388', component.options)
    } else {
      api.reload('f5c55388', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=f5c55388&scoped=true&", function () {
      api.rerender('f5c55388', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "preview/app.vue"
export default component.exports